// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import Modal from 'react-modal';
import { BrowserRouter as Router } from 'react-router-dom';

// --- Context Imports ---
import { AuthProvider } from './context/AuthContext';
import { DataProvider } from './context/DataContext'; // DataProvider is the Parent
import { JobProvider } from './context/jobContext'; // JobProvider is the Child

import 'normalize.css';
import './index.css';

// This will disable console logs in the production build
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
}

const rootElement = document.getElementById('root');

Modal.setAppElement('#root');

const root = createRoot(rootElement);

root.render(
  /*<React.StrictMode>*/
  <Router>
    <AuthProvider>
      <DataProvider>
        <JobProvider>
          <App />
        </JobProvider>
      </DataProvider>
    </AuthProvider>
  </Router>,
  /* </React.StrictMode>*/
);
